<template>
    <div :class="['tab__item-desktop-' + desktop + ' tab__item-mobile-' + mobile  + ' ' + activeClass]"
         @click="clickTab()">
            <ion-label>{{ tab.title }}</ion-label>
    </div>
</template>

<script>

    import {mapActions, mapGetters} from "vuex";


    export default {
        name: 'CustomTab',
        props: ['tabId', 'desktop', 'mobile'],
        methods: {
            ...mapActions(["updateBox", "getBoxes"]),
            clickTab: function (){
                if(this.activeClass !== 'active') {
                    this.tab.active = true;
                    this.updateBox(this.tab);
                    this.getBoxes();

                }
                window.scrollTo(0, 0);
            }
        },
        computed: {
            ...mapGetters(['allBoxes']),
            tab(){
                let tabId = this.tabId;
                let tmp = this.allBoxes.filter(function(box){
                    return box.id == tabId;
                });
                return tmp[0];

            },
            activeClass(){
                return  (this.tab.active === true ? 'active' : '' );
            }
        },
    }
</script>

<style scoped>
    @media only screen and (max-width: 767px) {
        .tab__item-mobile-,
        .tab__item-mobile-default {
            display: inline-block;
            margin: 25px 25px 0;
            text-align: center;
        }

        .icon {
            margin-top: 2px;
            margin-right: 5px;
        }
    }
    @media only screen and (min-width: 768px) {
        .tab__item-desktop-,
        .tab__item-desktop-default {
            margin-top: 20px;
            align-items: center;
            flex-direction: column;
            margin-right: 10px;
            border-top-left-radius: .25rem;
            border-top-right-radius: .25rem;
            background-color: #343638 !important;
            padding: 15px 20px;
            border: 0 !important;
            display: block;
            color: white
        }

        .tab__item-desktop- a,
        .tab__item-desktop-default a {

        }

        .active{
            background-color: #3E4143 !important;
            border: 0 !important;
        }

        .icon {
            display: none;
        }
    }

</style>